import { render, staticRenderFns } from "./WorkClaimNotes.vue?vue&type=template&id=26a35a44&scoped=true&"
import script from "./WorkClaimNotes.vue?vue&type=script&lang=js&"
export * from "./WorkClaimNotes.vue?vue&type=script&lang=js&"
import style0 from "./WorkClaimNotes.vue?vue&type=style&index=0&id=26a35a44&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "26a35a44",
  null
  
)

export default component.exports